<div style="border: 1px solid black;">
    <div style="display: flex; justify-content: flex-end;" (click)="hide()"><mat-icon
            style="cursor: pointer;">close</mat-icon></div>
    <img [src]="data.image" alt="" *ngIf="data.image" style="max-height: 400px;width: 100%;" class="zoomImage" />
    <video *ngIf="data.video" [src]="data.video" controls controlsList="nodownload" style="height: 100%;width: 100%;">
        <track label="English" kind="subtitles" srclang="en" default />
    </video>
</div>